import { isSegmentLoaded } from "./trailerLoadState";
import { TripForMileage, TripRouteSegment } from "./types";

export function buildTripRouteSegments(trip: TripForMileage): TripRouteSegment[] {
  const segments: TripRouteSegment[] = [];

  if (trip.routeStartPoint) {
    segments.push({
      kind: "endpoint",
      endpointType: "start",
      label: trip.routeStartPoint.label,
      endpoint: trip.routeStartPoint,
      distanceTo: trip.routeStartPoint.distance,
      isLoaded: false,
    });
  }

  trip.shipmentLocations.forEach((shipmentLocation, index) => {
    segments.push({
      kind: "stop",
      shipmentLocation,
      distanceTo: shipmentLocation.distanceTo,
      isLoaded: isSegmentLoaded(trip.shipmentLocations, index),
    });
  });

  if (trip.routeEndPoint) {
    segments.push({
      kind: "endpoint",
      endpointType: "end",
      label: trip.routeEndPoint.label,
      endpoint: trip.routeEndPoint,
      distanceTo: trip.routeEndPoint.distance,
      isLoaded: false,
    });
  }

  return segments;
}
